import { useCallback } from 'react'

import { toast } from 'react-toastify'

import { BookingChargeDefaultsByType } from 'constants/EntityConstants/OtherChargeEntity'
import { BookingChargeType } from 'generated/graphql'
import { TBookingAddressForm, TBookingChargeForm } from 'types/form-types'

import { isOutOfHoursTimestamp } from './utils'

type IUseOutOfHoursChargeSyncProps = {
  collectionAddresses: TBookingAddressForm[]
}

export const useOutOfHoursChargeSync = ({ collectionAddresses }: IUseOutOfHoursChargeSyncProps) => {
  const handleOutOfHoursChargesApplied = useCallback((charges: TBookingChargeForm[]) => {
    const existingOutOfHoursCharge = charges.find((x) => x?.type === BookingChargeType.OutOfHours)

    if (!existingOutOfHoursCharge) {
      const outOfHoursCharge = BookingChargeDefaultsByType[BookingChargeType.OutOfHours]
      if (outOfHoursCharge?.type) {
        charges.push({
          ...outOfHoursCharge,
          rate: outOfHoursCharge.rate ?? 0,
        })
        toast.info(`Automatic charge Out Of Hours was added.`)
      }
    }
  }, [])

  const handleOutOfHoursChargesRemoved = useCallback((charges: TBookingChargeForm[]) => {
    const existingOutOfHoursCharge = charges.find((x) => x?.type === BookingChargeType.OutOfHours)

    if (!existingOutOfHoursCharge) {
      return
    }

    charges.splice(
      0,
      charges.length,
      ...charges.filter((x) => x?.type !== BookingChargeType.OutOfHours),
    )
    toast.info(`Automatic charge Out Of Hours was removed.`)
  }, [])

  const handleOutOfHoursChargesSync = useCallback(
    (charges: TBookingChargeForm[]) => {
      if (!collectionAddresses?.length || collectionAddresses.length === 0) {
        return
      }

      const hasOutOfHoursCollectionAddress = collectionAddresses.some(
        (address) => isOutOfHoursTimestamp(address?.at) || isOutOfHoursTimestamp(address?.by),
      )

      if (hasOutOfHoursCollectionAddress) {
        handleOutOfHoursChargesApplied(charges)
      } else {
        handleOutOfHoursChargesRemoved(charges)
      }
    },
    [collectionAddresses, handleOutOfHoursChargesApplied, handleOutOfHoursChargesRemoved],
  )

  return { handleOutOfHoursChargesSync }
}
